export const svgStyles = {
  maxWidth: "660px",
  width: "60%",
  height: "auto",
  margin: "0 auto"
};
